
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-n6lfw8",
"minContentWidth": "--awsui-min-content-width-n6lfw8",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-n6lfw8",
"contentGapLeft": "--awsui-content-gap-left-n6lfw8",
"contentGapRight": "--awsui-content-gap-right-n6lfw8",
"contentHeight": "--awsui-content-height-n6lfw8",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-n6lfw8",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-n6lfw8",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-n6lfw8",
"defaultMaxContentWidth": "--awsui-default-max-content-width-n6lfw8",
"defaultMinContentWidth": "--awsui-default-min-content-width-n6lfw8",
"drawerSize": "--awsui-drawer-size-n6lfw8",
"drawerMinSize": "--awsui-drawer-min-size-n6lfw8",
"bottomDrawerSize": "--awsui-bottom-drawer-size-n6lfw8",
"footerHeight": "--awsui-footer-height-n6lfw8",
"headerGap": "--awsui-header-gap-n6lfw8",
"headerHeight": "--awsui-header-height-n6lfw8",
"layoutWidth": "--awsui-layout-width-n6lfw8",
"mainGap": "--awsui-main-gap-n6lfw8",
"mainOffsetLeft": "--awsui-main-offset-left-n6lfw8",
"mainTemplateRows": "--awsui-main-template-rows-n6lfw8",
"mobileBarHeight": "--awsui-mobile-bar-height-n6lfw8",
"notificationsHeight": "--awsui-notifications-height-n6lfw8",
"offsetTop": "--awsui-offset-top-n6lfw8",
"overlapHeight": "--awsui-overlap-height-n6lfw8",
"navigationWidth": "--awsui-navigation-width-n6lfw8",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-n6lfw8",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-n6lfw8",
"splitPanelHeight": "--awsui-split-panel-height-n6lfw8",
"splitPanelMinWidth": "--awsui-split-panel-min-width-n6lfw8",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-n6lfw8",
"toolsMaxWidth": "--awsui-tools-max-width-n6lfw8",
"toolsWidth": "--awsui-tools-width-n6lfw8",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-n6lfw8",
"contentScrollMargin": "--awsui-content-scroll-margin-n6lfw8",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-n6lfw8",
"flashbarStackIndex": "--awsui-flashbar-stack-index-n6lfw8",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-n6lfw8",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-n6lfw8",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-n6lfw8",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-n6lfw8",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-n6lfw8",
"modalCustomWidth": "--awsui-modal-custom-width-n6lfw8",
"modalCustomHeight": "--awsui-modal-custom-height-n6lfw8",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-n6lfw8",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-n6lfw8",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-n6lfw8",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-n6lfw8",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-n6lfw8",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-n6lfw8",
"sliderLabelCount": "--awsui-slider-label-count-n6lfw8",
"sliderTickCount": "--awsui-slider-tick-count-n6lfw8",
"sliderReferenceColumn": "--awsui-slider-reference-column-n6lfw8",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-n6lfw8",
"sliderMaxStart": "--awsui-slider-max-start-n6lfw8",
"sliderMinEnd": "--awsui-slider-min-end-n6lfw8",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-n6lfw8",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-n6lfw8",
"togglesLeftWidth": "--awsui-toggles-left-width-n6lfw8",
"togglesRightWidth": "--awsui-toggles-right-width-n6lfw8",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-n6lfw8",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-n6lfw8",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-n6lfw8",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-n6lfw8",
"styleBackgroundActive": "--awsui-style-background-active-n6lfw8",
"styleBackgroundDefault": "--awsui-style-background-default-n6lfw8",
"styleBackgroundDisabled": "--awsui-style-background-disabled-n6lfw8",
"styleBackgroundHover": "--awsui-style-background-hover-n6lfw8",
"styleBorderColorActive": "--awsui-style-border-color-active-n6lfw8",
"styleBorderColorDefault": "--awsui-style-border-color-default-n6lfw8",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-n6lfw8",
"styleBorderColorHover": "--awsui-style-border-color-hover-n6lfw8",
"styleColorActive": "--awsui-style-color-active-n6lfw8",
"styleColorDefault": "--awsui-style-color-default-n6lfw8",
"styleColorDisabled": "--awsui-style-color-disabled-n6lfw8",
"styleColorHover": "--awsui-style-color-hover-n6lfw8",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-n6lfw8",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-n6lfw8",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-n6lfw8",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-n6lfw8",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-n6lfw8",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-n6lfw8",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-n6lfw8",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-n6lfw8",
"styleBackgroundReadonly": "--awsui-style-background-readonly-n6lfw8",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-n6lfw8",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-n6lfw8",
"styleColorReadonly": "--awsui-style-color-readonly-n6lfw8",
"styleBackgroundFocus": "--awsui-style-background-focus-n6lfw8",
"styleBorderColorFocus": "--awsui-style-border-color-focus-n6lfw8",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-n6lfw8",
"styleColorFocus": "--awsui-style-color-focus-n6lfw8",
"stylePlaceholderColor": "--awsui-style-placeholder-color-n6lfw8",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-n6lfw8",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-n6lfw8",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-n6lfw8",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-n6lfw8",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-n6lfw8",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-n6lfw8",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-n6lfw8",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-n6lfw8",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-n6lfw8",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-n6lfw8",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-n6lfw8",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-n6lfw8",
"alertIconColor": "--awsui-alert-icon-color-n6lfw8",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-n6lfw8",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-n6lfw8",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-n6lfw8",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-n6lfw8",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-n6lfw8",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-n6lfw8",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-n6lfw8",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-n6lfw8",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-n6lfw8",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-n6lfw8",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-n6lfw8",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-n6lfw8",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-n6lfw8",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-n6lfw8",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-n6lfw8",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-n6lfw8",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-n6lfw8",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-n6lfw8",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-n6lfw8",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-n6lfw8",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-n6lfw8",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-n6lfw8",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-n6lfw8",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-n6lfw8",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-n6lfw8",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-n6lfw8",
"progressBarHeight": "--awsui-progress-bar-height-n6lfw8",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-n6lfw8",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-n6lfw8",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-n6lfw8",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-n6lfw8",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-n6lfw8",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-n6lfw8",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-n6lfw8",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-n6lfw8",
      };
      export default customCSSPropertiesMap;
    